import React, { Component } from "react";
import { Modal, Form, Button, Row, Col, Spinner, Badge } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import * as Cookies from "es-cookie";
import axios from "axios";
import Select from "react-select";
import MultiSelect from "react-multi-select-component";


const WA_GREEN = "#25D366";
const WA_TEAL = "#128C7E";

// Personalization tokens the backend substitutes per student (see
// waMessagingService.personalizeVariables).
const TOKENS = ["{name}", "{mobile}", "{class}", "{branch}", "{admission_no}"];

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
    }
  }
`;

const GET_RECIPIENTS = gql`
  query getCombinedAcademicAndNonAcademicStudents($institution_id: Int!, $branch_id: String) {
    getCombinedAcademicAndNonAcademicStudents(institution_id: $institution_id, branch_id: $branch_id) {
      edu_student_id
      student_name
      roll_no
      class_id
      class_name
      branch_id
      branch_name
      section_id
      section_name
      contact_no
    }
  }
`;

class SendTemplateToStudentsModal extends Component {
  state = {
    templateId: "",
    selectedBranch: null,
    selectedClasses: [],
    selectedSections: [],
    selectedStudents: [], // list of edu_student_id
    headerInputs: [],
    bodyInputs: [],
    sending: false,
    result: null,
  };

  placeholders = (text) => (text || "").match(/\{\{(\d+)\}\}/g) || [];

  selectedTemplate = () =>
    (this.props.templates || []).find((t) => String(t.id) === String(this.state.templateId));

  onTemplateChange = (e) => {
    const id = e.target.value;
    const t = (this.props.templates || []).find((x) => String(x.id) === String(id));
    const h = this.placeholders(t && t.headerText);
    const b = this.placeholders(t && t.body);
    this.setState({
      templateId: id,
      headerInputs: Array(h.length).fill(""),
      bodyInputs: Array(b.length).fill(""),
      result: null,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { branchesQuery } = this.props;
    if (branchesQuery && !branchesQuery.loading && branchesQuery.getBranches && branchesQuery.getBranches.length > 0) {
      if (!this.state.selectedBranch) {
        const firstBranch = branchesQuery.getBranches[0];
        const selectedBranch = { value: firstBranch.id, label: firstBranch.branch_name };
        this.setState({ selectedBranch });
        
        const { recipientsQuery } = this.props;
        if (recipientsQuery && recipientsQuery.refetch) {
          recipientsQuery.refetch({
            institution_id: this.props.institutionId,
            branch_id: String(firstBranch.id),
          });
        }
      }
    }
  }

  onBranchChange = (selectedBranch) => {
    this.setState({
      selectedBranch,
      selectedClasses: [],
      selectedSections: [],
      selectedStudents: [],
      result: null
    });
    const { recipientsQuery } = this.props;
    if (recipientsQuery && recipientsQuery.refetch) {
      recipientsQuery.refetch({
        institution_id: this.props.institutionId,
        branch_id: selectedBranch ? String(selectedBranch.value) : null,
      });
    }
  };

  onClassChange = (selectedClasses) => {
    const classes = selectedClasses || [];
    this.setState({
      selectedClasses: classes,
      selectedSections: [],
      selectedStudents: [],
      result: null
    });
  };

  onSectionChange = (selectedSections) => {
    const sections = selectedSections || [];
    this.setState({
      selectedSections: sections,
      selectedStudents: [],
      result: null
    }, () => {
      const filtered = this.getFilteredStudents();
      this.setState({ selectedStudents: filtered.map((s) => s.edu_student_id) });
    });
  };

  getStudentsList = () => {
    const q = this.props.recipientsQuery || {};
    return q.getCombinedAcademicAndNonAcademicStudents || [];
  };

  getClasses = () => {
    const students = this.getStudentsList();
    const classes = [];
    const seen = new Set();
    students.forEach((s) => {
      if (s.class_id && !seen.has(s.class_id)) {
        seen.add(s.class_id);
        classes.push({ value: s.class_id, label: s.class_name || `Class ${s.class_id}` });
      }
    });
    return classes;
  };

  getSections = () => {
    const students = this.getStudentsList();
    const { selectedClasses } = this.state;
    const classIds = (selectedClasses || []).map(c => Number(c.value));
    
    if (classIds.length === 0) return [];
    
    const sections = [];
    const seen = new Set();
    students.forEach((s) => {
      if (classIds.includes(Number(s.class_id)) && s.section_id && !seen.has(s.section_id)) {
        seen.add(s.section_id);
        sections.push({ value: s.section_id, label: s.section_name || `Section ${s.section_id}` });
      }
    });
    return sections;
  };

  getFilteredStudents = () => {
    const students = this.getStudentsList();
    const { selectedClasses, selectedSections } = this.state;
    const classIds = (selectedClasses || []).map(c => Number(c.value));
    const sectionIds = (selectedSections || []).map(s => Number(s.value));
    
    if (classIds.length === 0 || sectionIds.length === 0) return [];
    
    return students.filter((s) => 
      classIds.includes(Number(s.class_id)) && 
      sectionIds.includes(Number(s.section_id))
    );
  };

  handleStudentCheck = (studentId) => {
    const { selectedStudents } = this.state;
    if (selectedStudents.includes(studentId)) {
      this.setState({ selectedStudents: selectedStudents.filter((id) => id !== studentId) });
    } else {
      this.setState({ selectedStudents: [...selectedStudents, studentId] });
    }
  };

  handleSelectAllToggle = () => {
    const filtered = this.getFilteredStudents();
    const filteredIds = filtered.map((s) => s.edu_student_id);
    const { selectedStudents } = this.state;
    const allSelected = filteredIds.every((id) => selectedStudents.includes(id));

    if (allSelected) {
      this.setState({ selectedStudents: selectedStudents.filter((id) => !filteredIds.includes(id)) });
    } else {
      this.setState({ selectedStudents: [...new Set([...selectedStudents, ...filteredIds])] });
    }
  };

  recipientCount = () => {
    const { selectedStudents } = this.state;
    return selectedStudents.length;
  };

  setVar = (kind, i, val) => {
    const key = kind === "header" ? "headerInputs" : "bodyInputs";
    const arr = [...this.state[key]];
    arr[i] = val;
    this.setState({ [key]: arr });
  };

  insertToken = (kind, i, token) => {
    const key = kind === "header" ? "headerInputs" : "bodyInputs";
    const arr = [...this.state[key]];
    arr[i] = (arr[i] || "") + token;
    this.setState({ [key]: arr });
  };

  buildVariables = () => {
    const { headerInputs, bodyInputs } = this.state;
    const variables = [];
    if (headerInputs.length) {
      variables.push({
        type: "header",
        parameters: headerInputs.map((text) => ({ type: "text", text, mode: "static", key: "" })),
      });
    }
    if (bodyInputs.length) {
      variables.push({
        type: "body",
        parameters: bodyInputs.map((text) => ({ type: "text", text, mode: "static", key: "" })),
      });
    }
    return variables;
  };

  send = async () => {
    const t = this.selectedTemplate();
    if (!t) {
      this.setState({ result: { success: false, message: "Please select a template" } });
      return;
    }
    const { selectedStudents } = this.state;
    if (selectedStudents.length === 0) {
      this.setState({ result: { success: false, message: "Please select at least one student recipient" } });
      return;
    }
    this.setState({ sending: true, result: null });
    try {
      const res = await axios.post(
        `${this.props.apiBase}/wa/send-template-students`,
        {
          institution_id: this.props.institutionId,
          branch_id: this.state.selectedBranch ? String(this.state.selectedBranch.value) : null,
          class_id: this.state.selectedClasses ? this.state.selectedClasses.map(c => c.value).join(",") : null,
          section_id: this.state.selectedSections ? this.state.selectedSections.map(s => s.value).join(",") : null,
          student_ids: selectedStudents,
          template_id: t.id,
          variables: this.buildVariables(),
        },
        { headers: { Authorization: `Bearer ${Cookies.get("token") || ""}` } }
      );
      this.setState({ result: res.data });
    } catch (e) {
      this.setState({
        result: { success: false, message: e.response?.data?.message || e.message || "Failed to send" },
      });
    } finally {
      this.setState({ sending: false });
    }
  };

  renderVarInputs(kind, count) {
    if (!count) return null;
    const key = kind === "header" ? "headerInputs" : "bodyInputs";
    const label = kind === "header" ? "Header variables" : "Message variables";
    return (
      <div className="mb-2">
        <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4 }}>{label}</div>
        {this.state[key].map((val, i) => (
          <div key={i} className="mb-2">
            <Form.Control
              size="sm"
              value={val}
              placeholder={`Value for {{${i + 1}}} (type text or insert a token)`}
              onChange={(e) => this.setVar(kind, i, e.target.value)}
            />
            <div style={{ marginTop: 3 }}>
              {TOKENS.map((tok) => (
                <Badge
                  key={tok}
                  variant="light"
                  onClick={() => this.insertToken(kind, i, tok)}
                  style={{ cursor: "pointer", marginRight: 4, border: "1px solid #d1d5db", color: WA_TEAL, fontWeight: 500 }}
                >
                  {tok}
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { show, onClose, templates = [], branchesQuery = {} } = this.props;
    const { templateId, selectedBranch, selectedClasses, selectedSections, selectedStudents, sending, result } = this.state;
    const t = this.selectedTemplate();
    const headerCount = this.placeholders(t && t.headerText).length;
    const bodyCount = this.placeholders(t && t.body).length;
    const branches = branchesQuery.getBranches || [];
    
    const branchesOptions = branches.map((b) => ({ value: b.id, label: b.branch_name }));
    const classes = this.getClasses();
    const sections = this.getSections();
    const filteredStudents = this.getFilteredStudents();
    const count = this.recipientCount();
    const loadingCount = (this.props.recipientsQuery || {}).loading;

    return (
      <Modal show={show} onHide={onClose} centered size="lg">
        <Modal.Header style={{ background: `linear-gradient(135deg, ${WA_TEAL}, ${WA_GREEN})`, color: "#fff", border: "none" }}>
          <div className="d-flex align-items-center">
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10 }}>
              <i className="fab fa-whatsapp" style={{ fontSize: 20 }} />
            </div>
            <div>
              <Modal.Title style={{ fontSize: "1.05rem", fontWeight: 600 }}>Send Template to Students</Modal.Title>
            </div>
          </div>
          <button type="button" className="close" style={{ color: "#fff", opacity: 0.9, fontSize: 26 }} onClick={onClose}>
            <span>&times;</span>
          </button>
        </Modal.Header>

        <Modal.Body style={{ minHeight: "480px" }}>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Branch</Form.Label>
                <Select
                  options={branchesOptions}
                  value={selectedBranch}
                  onChange={this.onBranchChange}
                  placeholder="Choose branch..."
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Class</Form.Label>
                <MultiSelect
                  overrideStrings={{ allItemsAreSelected: "All Classes selected", selectSomeItems: "Choose class(es)..." }}
                  options={classes}
                  value={selectedClasses}
                  onChange={this.onClassChange}
                  labelledBy="Class"
                  disabled={!selectedBranch}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Section</Form.Label>
                <MultiSelect
                  overrideStrings={{ allItemsAreSelected: "All Sections selected", selectSomeItems: "Choose section(s)..." }}
                  options={sections}
                  value={selectedSections}
                  onChange={this.onSectionChange}
                  labelledBy="Section"
                  disabled={!selectedClasses || selectedClasses.length === 0}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Template</Form.Label>
                <Form.Control as="select" size="sm" value={templateId} onChange={this.onTemplateChange}>
                  <option value="">Choose template...</option>
                  {templates.map((tpl) => (
                    <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {/* Recipient Checklist */}
          {selectedSections && selectedSections.length > 0 && (
            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
                  Recipients ({selectedStudents.length} of {filteredStudents.length})
                </span>
                {filteredStudents.length > 0 && (
                  <Form.Check
                    type="checkbox"
                    id="wa-select-all-students"
                    label="Select All"
                    checked={filteredStudents.length > 0 && filteredStudents.every(s => selectedStudents.includes(s.edu_student_id))}
                    onChange={this.handleSelectAllToggle}
                    style={{ fontSize: 12.5, fontWeight: 600 }}
                  />
                )}
              </div>
              <div 
                className="border rounded p-3" 
                style={{ maxHeight: "260px", overflowY: "auto", background: "#f8fafc" }}
              >
                {filteredStudents.length > 0 ? (
                  filteredStudents.map(student => (
                    <Form.Check
                      key={student.edu_student_id}
                      type="checkbox"
                      id={`wa-student-check-${student.edu_student_id}`}
                      label={`${student.roll_no ? `${student.roll_no} - ` : ""}${student.student_name} (${student.contact_no || "No Mobile"})`}
                      checked={selectedStudents.includes(student.edu_student_id)}
                      onChange={() => this.handleStudentCheck(student.edu_student_id)}
                      className="mb-2 recipient-checkbox"
                      disabled={!student.contact_no}
                    />
                  ))
                ) : (
                  <div className="text-center text-muted py-3" style={{ fontSize: 13.5 }}>No students found in this section.</div>
                )}
              </div>
            </Form.Group>
          )}

          <div style={{ background: "#e7f9ee", borderRadius: 8, padding: "8px 12px", fontSize: 13, color: "#0f5132", marginBottom: 12 }}>
            <i className="fas fa-users mr-2" />
            {loadingCount ? "Counting recipients…" : <><strong>{count}</strong> student{count === 1 ? "" : "s"} will receive this message</>}
          </div>

          {t ? (
            <>
              {t.body && (
                <div style={{ background: "#d9fdd3", borderRadius: "8px", padding: "10px 14px", fontSize: 13, color: "#111b21", marginBottom: 12, whiteSpace: "pre-wrap", boxShadow: "0 1px 0.5px rgba(11,20,26,.13)", borderLeft: `4px solid ${WA_TEAL}` }}>
                  {t.headerText ? <div style={{ fontWeight: 700, color: WA_TEAL, marginBottom: 4 }}>{t.headerText}</div> : null}
                  {t.body}
                  {t.footer ? <div style={{ color: "#667781", fontSize: 11, marginTop: 6, borderTop: "1px solid rgba(0,0,0,0.05)", paddingTop: 4 }}>{t.footer}</div> : null}
                </div>
              )}
              {this.renderVarInputs("header", headerCount)}
              {this.renderVarInputs("body", bodyCount)}
              {(headerCount > 0 || bodyCount > 0) && (
                <small className="text-muted">
                  Tip: insert a token (e.g. <code>{"{name}"}</code>) to personalize each student's message.
                </small>
              )}
            </>
          ) : (
            <div className="text-center text-muted py-4" style={{ fontSize: 13 }}>
              Select a template to configure and preview it.
            </div>
          )}

          {result && (
            <div
              className="mt-3"
              style={{
                borderRadius: 8,
                padding: "10px 12px",
                fontSize: 13,
                background: result.success ? "#e7f9ee" : "#fde8e8",
                color: result.success ? "#0f5132" : "#842029",
              }}
            >
              {result.success ? (
                <>
                  <i className="fas fa-check-circle mr-2" />
                  Sent to <strong>{result.sent}</strong> of {result.total}.
                  {result.failed > 0 && <> ({result.failed} failed)</>}
                </>
              ) : (
                <>
                  <i className="fas fa-exclamation-circle mr-2" />
                  {result.message || "Failed to send"}
                </>
              )}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={onClose} disabled={sending}>Close</Button>
          <Button
            onClick={this.send}
            disabled={sending || !templateId || !selectedSections || selectedSections.length === 0 || count === 0}
            style={{ background: WA_GREEN, border: "none" }}
          >
            {sending ? (<><Spinner animation="border" size="sm" className="mr-2" />Sending…</>) : (<><i className="fab fa-whatsapp mr-2" />Send to {count} student{count === 1 ? "" : "s"}</>)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default compose(
  graphql(GET_BRANCHES, {
    name: "branchesQuery",
    options: (props) => ({ variables: { institution_id: props.institutionId } }),
  }),
  graphql(GET_RECIPIENTS, {
    name: "recipientsQuery",
    options: (props) => ({
      variables: { institution_id: props.institutionId, branch_id: null },
      fetchPolicy: "cache-and-network",
    }),
  })
)(SendTemplateToStudentsModal);
